import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4bff8aea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bankDetailPage" }
const _hoisted_2 = { class: "bankCart" }
const _hoisted_3 = { style: {"width":"90%","min-width":"800px"} }

import API from "@/api";
import { ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import ShareTrigger from "@/components/trigger/ShareTrigger.vue";
import router from "@/router";
import { getInterviewQuestionBankVoByIdUsingGet } from "@/request/api/interviewQuestionBankController";
import InterviewQuestionTable from "@/components/list/InterviewQuestionTable.vue";

interface Props {
  id: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BankDetailPage',
  props: {
    id: { default: () => {
    return 0;
  } }
  },
  setup(__props: any) {

const props = __props;

const data = ref<API.InterviewQuestionBankVO>({});
const loading = ref(false);
/**
 * 加载数据
 */
const loadData = async () => {
  loading.value = true;
  if (!props.id || props.id === 0) {
    return;
  }
  const response = await getInterviewQuestionBankVoByIdUsingGet({
    id: props.id,
  });
  if (response.data.code === 0 && response.data.data) {
    data.value = response.data.data;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});
/**
 * 答题
 */
const answer = () => {
  router.push({
    path: `/interviewQuestion/detail/${props.id}/${-1}`,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_spin, { loading: loading.value }, {
        default: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_image, {
                src: data.value.picture,
                width: "100",
                style: {"padding":"50px"}
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_typography_title, { style: {"font-weight":"bolder"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.value.title), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { style: {"margin-top":"-30px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_typography_text, { type: "secondary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.value.description), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          shape: "round",
                          onClick: answer
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 开始刷题 ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, { shape: "round" }, {
                          default: _withCtx(() => [
                            _createVNode(ShareTrigger)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(InterviewQuestionTable, {
      "bank-id": props.id
    }, null, 8, ["bank-id"])
  ]))
}
}

})